module.exports = __webpack_public_path__ + "img/signup-carousel-third@2x.1b362007.png";